class WhereToBuyHero extends HTMLElement {
  connectedCallback() {
    this.dropdown = this.querySelector('.where-to-buy-hero__dropdown');
    this.ddBtn = this.querySelector('.where-to-buy-hero__dd-btn');
    this.ddMenu = this.querySelector('.where-to-buy-hero__dd-menu');
    this.ddCur = this.querySelector('.where-to-buy-hero__dd-cur');
    this.panels = this.querySelectorAll('.where-to-buy-hero__country-panel');
    if (!this.dropdown || !this.ddBtn || !this.ddMenu) return;

    this.ddBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleMenu();
    });

    this.ddMenu.addEventListener('click', (e) => {
      const opt = e.target.closest('.where-to-buy-hero__dd-opt');
      if (!opt) return;
      this.selectCountry(opt);
    });

    document.addEventListener('click', (e) => {
      if (!this.dropdown.contains(e.target)) this.closeMenu();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeMenu();
    });
  }

  toggleMenu() {
    const open = this.dropdown.getAttribute('data-open') === 'true';
    this.dropdown.setAttribute('data-open', open ? 'false' : 'true');
    this.ddBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
  }

  closeMenu() {
    this.dropdown.setAttribute('data-open', 'false');
    this.ddBtn.setAttribute('aria-expanded', 'false');
  }

  selectCountry(opt) {
    const id = opt.getAttribute('data-country-id');

    this.ddMenu.querySelectorAll('.where-to-buy-hero__dd-opt').forEach((o) => {
      o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
    });
    if (this.ddCur) this.ddCur.textContent = opt.querySelector('span')?.textContent || '';

    this.panels.forEach((panel) => {
      panel.hidden = panel.getAttribute('data-country-id') !== id;
    });

    this.closeMenu();
  }
}

customElements.define('where-to-buy-hero', WhereToBuyHero);
